export const pathsSaldo: { [path: string]: string } = {
    API_PATH: 'v3/',
    API_PATH_INTERNAL: '/internal/',
    AUTH_PATH: 'auth/v1/',
    SOCKET_AUTH_PATH: 'broadcasting/auth'
};
